import {Component, Input, OnInit} from '@angular/core';
import {Plugins, StatusBarStyle} from '@capacitor/core';
import {Platform} from '@ionic/angular';

const AndroidStatusBar = Plugins.StatusBar;

@Component({
    selector: 'app-big-header',
    templateUrl: './big-header.component.html',
    styleUrls: ['./big-header.component.css'],
})
export class BigHeaderComponent implements OnInit {

    @Input() title = '';

    constructor(private platform: Platform) {
    }

    ngOnInit() {
        if (this.platform.is('android')) {
            AndroidStatusBar.setStyle({style: StatusBarStyle.Light});
            AndroidStatusBar.setBackgroundColor({
                color: '#EDE3D7',
            });
        }
    }

}
